import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

const reactivateUserFactory = () => {
  const query = `
    mutation reactivateUser($userId: ID!) {
      reactivateUser(userId: $userId) {
        successMessage
      }
    } 
  `;

  const resolver = ({ data }) => {
    return data;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

function useReactivateUser(reactivatedUserId, onReactivated) {
  const [submit, { loading }] = useMutationWithToaster(reactivateUserFactory, {
    onDone: useCallback(() => {
      onReactivated();
    }, [onReactivated]),
  });

  return {
    onSubmit: useCallback(async () => {
      await submit(
        { userId: reactivatedUserId },
        {
          successMsg: "User reactivated successfully",
          defaultErrorMsg: "Failed to reactivate user",
        }
      );
    }, [reactivatedUserId, submit]),
    loading: loading,
  };
}

export default useReactivateUser;
